import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IProjects } from '../../Interfaces/IProjects';
import { ProjectsService } from '../../services/projects-services';
import { NDAManagementService } from '../../services/ndaManagement-services';
import { TranslateService } from '../../../../../core/services/translate-service';
import { TranslateApplicationService } from '../../../../../core/translate/translate-application-service';
import { INDAManagement } from '../../Interfaces/INDAManagement';

@Component({
  selector: 'project-assign-nda',
  templateUrl: 'project-assign-nda.html',
  styleUrls: ['../projects.component.scss']
})
export class ProjectAssignNDA {
  formGroup: FormGroup;
  listData: INDAManagement[];
  listNDAProjectsData: INDAManagement[];
  loading = false;
  station: string = 'TABLE';
  columns: Array<any> = ['ndamanagementname', 'disablecolumn'];
  displayedColumns: Array<string> = this.columns.map(c => c.columnDef);

  constructor(
    private dialogRef: MatDialogRef<ProjectAssignNDA>,
    @Inject(MAT_DIALOG_DATA) public data: IProjects,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private projectService: ProjectsService,
    private ndaManagementService: NDAManagementService,
    private formBuilder: FormBuilder,
    public translate: TranslateApplicationService
  ) {
    this.formGroup = this.formBuilder.group({
      pkproject: [data.pkproject, Validators.required],
      fkndamanagement: [null, Validators.required],
    });
  }
  //button save for add/edit
  ngOnInit() {
    this.GetNDAManagements();
    this.GetNDAByProject();
  }
  
  GetNDAManagements() {
    this.loading = true;
    this.ndaManagementService.GetAvailableProjectsNDAs().subscribe( 
      (result: TransactionResult<INDAManagement[]>) => {
        this.loading = false;
        if (result.success) {
          this.listData = result.data;
          
        }
        else{
          this.ErrorAlert(result.message);
        }
      },
      (error: any) => { this.ErrorAlert(error); this.loading = false; }
    );
  }

  GetNDAByProject() {
    this.loading = true;
    this.projectService.GetNDAByProject(this.formGroup.value).subscribe( 
      (result: TransactionResult<INDAManagement[]>) => {
        this.loading = false;
        if (result.success) {
          this.listNDAProjectsData = result.data;
        }
        else{
          this.ErrorAlert(result.message);
        }
      },
      (error: any) => { this.ErrorAlert(error); this.loading = false; }
    );
  }

  AddNDA(){
    this.loading = true;
    if (this.formGroup.valid) {
      this.loading = true;
      this.projectService.AddNDA(this.formGroup.value).subscribe(
        (result: TransactionResult<boolean>) => {
          this.loading = false;
          if (result.success) { 
            this.Alert(); 
            this.formGroup.controls.fkndamanagement.setValue(0);
            this.GetNDAByProject();
          }
          else{
            this.ErrorAlert(result.message);
          }
        },
        (error: any) => { this.ErrorAlert(error); this.loading = false; }
      );
    }
    else{
      this.loading = false;
      this.notificationService.AddAlert({
        icon: 'all_inbox',
        title: 'Warning',
        message: this.translate.TranslateKey('COMPLETE_FORM'),
        shown: true
      });
    }
  }

  DisableNDA(item: IProjects){
    this.loading = true;
    this.projectService.DisableProjectNDA(item).subscribe(
      (result: TransactionResult<boolean>) => {
        this.loading = false;
        if (result.data)
        { 
          this.GetNDAByProject();
          this.Alert(); 
        }
        else {
          this.AlertMessage(
            'Warning',
            this.translate.TranslateKey('WARNING.Failed_updated_status'),
          );
        }
      },
      (error: any) => { this.ErrorAlert(error); this.loading = false; }
    );
  }

  Close() {
    this.dialogRef.close(true);
  }

  Alert() {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Success',
      message: this.translate.TranslateKey('COMPLETE'),
      shown: true
    });
  }

  AlertMessage(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: message,
			shown: true,
		});
  }

  ErrorAlert(message: any) {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Error',
      message: message,
      shown: true,
    });
  }
}
